
import React, { createContext, useContext } from 'react';
import { useUserRole, useIsAdminOrModerator } from '@/hooks/useUserRole';

interface SecurityContextType {
  userRole: string | null;
  isAdmin: boolean;
  isModerator: boolean;
  isAdminOrModerator: boolean;
  isLoading: boolean;
}

const SecurityContext = createContext<SecurityContextType | undefined>(undefined);

export const SecurityProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { data: userRole, isLoading } = useUserRole();
  const isAdminOrModerator = useIsAdminOrModerator();
  
  const value: SecurityContextType = {
    userRole,
    isAdmin: userRole === 'Yönetici',
    isModerator: userRole === 'Moderatör',
    isAdminOrModerator,
    isLoading
  };

  return (
    <SecurityContext.Provider value={value}>
      {children}
    </SecurityContext.Provider>
  );
};

export const useSecurity = () => {
  const context = useContext(SecurityContext);
  if (context === undefined) {
    throw new Error('useSecurity must be used within a SecurityProvider');
  }
  return context;
};
